import { Box, Grid, Typography } from "@mui/material";
import { MainCard } from "../../layoutPages/components/MainCard";
import { ShortCut } from "../../system/ShortCut";
import { ParentMeetingTopButtons } from "./ParentMeetingTopButtons";
import { DefaultSetting } from "../../layoutPages/defaultSetting";

interface ParentPhotoData {
    name: string;
    open: string;
    cover: string;
}

export function ParentPhoto() {
    let data: Array<ParentPhotoData> = [
        
        {
            name: "2021.9.17培僑機構舊生家長聯會成立典禮",
            open: "https://photos.app.goo.gl/gxm4eWVZZ7bAidtp7",
            cover: "https://lh3.googleusercontent.com/pw/AP1GczOts7MXN7mOVCF0fU45zpuJmRF9r4qrnRvOZw8AFVvni22Fkw8jdEuxKqgvXrwzj2h5J-yHqnDolKwaVnyZw00GBhPdmJYNcLLR9B6iCMpi7jA7WHKRhv8pS90p5o-z-GcU4bzaFxJu866lZaaAnWD_=w1318-h879-s-no-gm?authuser=0"
        },
        {
            name: "2021.12.11聯會會員茶聚",
            open: "https://photos.app.goo.gl/vPx2HxieLttHJRYF8",
            cover: "https://lh3.googleusercontent.com/pw/AP1GczMuSEjfYE_yTrcRJ96kwUjTYQgrS8jN8bOqLTI0FC9UveFjut70_zBHKeTmI3d4jsdSdlu-n__dfhexued4Io-WpeGDU54lwx_2XdaLs8XL284cvMd0wsFGFs7-MH49UWn5H8WP74nrogwrgfi9ETEg=w1318-h879-s-no-gm?authuser=0"
        },
        {
            name: "2022.7.23聯會慶回歸茶聚",
            open: "https://photos.app.goo.gl/bnKbW37HB2eYYy227",
            cover: "https://lh3.googleusercontent.com/pw/AP1GczMe6BLxEY4KneuO-Gp056QuObLvwjXAV_C4U98THfV82rQTZXbSA5krWogcYa-NSa2G-OCyT8ohgDPeCdQu76KyNfx3dW4nDU_zOQpqeFggI8Vnyfk4gCzB5pkwzzDsNCNnJ5MBDpUFo7UziIfu1Zep=w1318-h879-s-no-gm?authuser=0"
        },
        {
            name: "2022.11.27聯會本地一日遊",
            open: "https://photos.app.goo.gl/VwDReCiZGpfSkjxA9",
            cover: "https://lh3.googleusercontent.com/pw/AP1GczOyOBhI-T8obJZhgINxTr1ZtNFOfG2eQPKJj6czXw_TXK3SNH4UYC08RmPAUPJK_UlprcGvqBmx3Zi7IzvSUN_yY1sH-t1tdoKBMXXGVmkHv5ZcAkzPGDZ34cG-qvBzRo6wsTNmk8XRemVUaW5YB0_F=w1318-h988-s-no-gm?authuser=0"
        },
        {
            name: "2023.2.18培書盆菜宴",
            open: "https://photos.app.goo.gl/7D7EsEqsMA9xJqt46",
            cover: "https://lh3.googleusercontent.com/pw/AP1GczPzyEP30RSmvH4NcAPYbhrQzczEttkdITJmBrvB80f2vS3UlBef9BcJb2312aUE5BSfY4lJpsBRhrrQ2yqDCZb3gRGP7dAB6dStYkDpNCfprMR1zO5AX9Koixa9Uyyk_X5EI6QeJ8xOO-OtgEaxczj9=w1318-h989-s-no-gm?authuser=0"
        },
        {
            name: "2023.4.22深圳一日遊",
            open: "https://photos.app.goo.gl/gGzxSDt9Ln3tngA66",
            cover: "https://lh3.googleusercontent.com/pw/AP1GczMhLZLI1S1A9_z0WTxhLN5aIprXiJzRQzOhHB8vQWxfGgQzXMjr-EQLf9vo1YIEMeQj9JiMUPEzS6mwkrBTNU1n6W67Hkl8kqKs0wXSyPU1O5hpSxrDbYk3vsYOwcpjHueQ8H-PM4Eyokfc2-0U0Bco=w1318-h879-s-no-gm?authuser=0"
        },
        {
            name: "2024.1.20 全家同樂 燒烤聚會",
            open: "https://photos.app.goo.gl/pk5gSgpzGsUusxfs6",
            cover: "https://lh3.googleusercontent.com/pw/AP1GczNjyeTzk6PQYUAFEZ7_k7v96RcJRpXuM_Yel3sEzcTI6ymuCBFwOYQ6O4exBlD1U3_bKdN-juUwu3cEDZJr5vYXe7n31uObGyIXCew31AJN1ah0OMCnw7fIm7rBv_NcBFBv6ydccwafzg6PCUkj1Zxc=w1318-h879-s-no-gm?authuser=0"
        },
        {
            name: "2024.3.15賀新春盆菜宴暨第二屆理事就職",
            open: "https://photos.app.goo.gl/iJeW3KYYKVeHPjJZ6",
            cover: "https://lh3.googleusercontent.com/pw/AP1GczNS5sDuvMFGip-z5U7QHwIw2ek6WX57qTf9WxxQVzpFIe8vdAwrj74hGZxqssOkvjkTS4JDNTPbJrHwbgNFriOotXcY02BVaeFe_rv2we1Qg-8y4LlLSr-UjVw8pcRHozY-N8xNG4M7mK19aOt1WDYN=w1318-h879-s-no-gm?authuser=0"
        },
        {
            name: "2024.6.15深圳一天遊",
            open: "https://photos.app.goo.gl/Tk5jh7XMuByxobLbA",
            cover: "https://lh3.googleusercontent.com/pw/AP1GczOlD2_Xl8C-UMK4PUNFCQWx_CQaHmALQebe_0EMW6BIr4FtVeyC4sNtlgZKmuM6JyU0zdy3rYaN_szg2-JvBigkdA24QDM7ynGwGqULzfI4gampgzdk2R5cSzIijeeCBs5wKL6u4b9jQvHJZmq5NHT3=w1579-h914-s-no?authuser=0"
        },
        {
            name: "2024.7.28聯會慶回歸茶聚",
            open: "https://photos.app.goo.gl/cKi8DDgnQHq2KPku9",
            cover: "https://lh3.googleusercontent.com/pw/AP1GczPI1WhcjO1pMHFYatiYRXZMRDbv6UqUIIR2khXXXprYnueSyHSfJNQBNH47dzHjWp6TP433Enx2B7mZp6EmsEwETo-ZDEkdm2tXbPjXyt_Sr8i6grMrDBA7Ok0wCfURyD-LQR6PljZHOPSs0mWbbIRS=w1318-h988-s-no-gm?authuser=0"
        },
        {
            name: "2024.12.1珠海文化考察團",
            open: "http://www.pkps.edu.hk/photos/2425/202412121129/album.html",
            cover: "http://www.pkps.edu.hk/photos/2425/202412121129/25.jpg"
        },
        {
            name: "2025.02.28會員大會暨春節盆菜宴",
            open: "https://photos.app.goo.gl/Mca8zpb9fDJG2Tka9",
            cover: "https://lh3.googleusercontent.com/pw/AP1GczM0RKpOMj1r4ZWpuDbx0J8TwFZvjbSvSWSgBZcjsL2lba5w2jGH6Rb5KzCPEyOHrHcx3P21uFc2ZF5mnKiaimlbc73wONL3tQMHXhNLJQ_4M5MtK-yGaT_LzMwT2frOGY152TR3cnQTHHzI75_bVnuR=w1371-h914-s-no?authuser=1"
        }
    ]

    data.reverse();
    return (
        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
            <ParentMeetingTopButtons />
            <Grid item xs={11} sm={10} >
                <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>

                    {
                        data.map((item) => (
                            <Grid item xs={5} sm={5}>
                                <MainCard
                                    src={item.cover}
                                    onClick={() => ShortCut.windowOpen(item.open)}
                                    imgHeight={"180px"}
                                    noImgPopup
                                    caption={
                                        <Typography variant='h6' align={"center"} sx={{ color: DefaultSetting.secondColor, textTransform: "none"}}>
                                            {item.name}
                                        </Typography>
                                    }
                                    sx={{ m: 0.5, height: "auto" }}
                                />
                            </Grid>
                        ))
                    }
                </Grid>
            </Grid>
        </Grid>
    )
}